function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M175,12.5H25c-6.9,0-12.5,5.6-12.5,12.5v150c0,6.9,5.6,12.5,12.5,12.5h115.6c3.5,0,6.2-2.8,6.2-6.2 s-2.8-6.2-6.2-6.2H25V25h150v115.6c0,3.5,2.8,6.2,6.2,6.2s6.2-2.8,6.2-6.2V25C187.5,18.1,181.9,12.5,175,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M154.6,145.8c5.1-6.9,7.9-15.3,7.9-23.9c0-22.4-18.2-40.6-40.6-40.6s-40.6,18.2-40.6,40.6 s18.2,40.6,40.6,40.6c8.6,0,17-2.8,23.9-7.9l21.7,21.7c2.4,2.4,6.4,2.5,8.8,0c0,0,0,0,0,0c2.4-2.4,2.4-6.4,0-8.8c0,0,0,0,0,0 L154.6,145.8L154.6,145.8z M93.8,121.9c0-15.5,12.6-28.1,28.1-28.1s28.1,12.6,28.1,28.1S137.4,150,121.9,150S93.8,137.4,93.8,121.9z  M156.2,51.6c0-3.5-2.8-6.2-6.2-6.2H50c-3.5,0-6.2,2.8-6.2,6.2c0,3.5,2.8,6.2,6.2,6.2h100C153.5,57.8,156.2,55,156.2,51.6z M50,82.6 c-3.5,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2h18.8c3.5,0,6.2-2.8,6.2-6.2s-2.8-6.2-6.2-6.2H50z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.82796afb20d096d07d90eb0e2a23dece.svg";
export { ForwardRef as ReactComponent };